import FeaturesCarousel from './featurescarousel';

export default FeaturesCarousel;